export default [
  {
    path: '/admin/org-authority/role/index',
    name: 'M020002',
    component: () => import('@/views/admin/org-authority/role/RoleIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/org-authority/staff-org/org-index',
    name: 'M020008',
    component: () =>
      import('@/views/admin/org-authority/staff-org/OrgIndex.vue'),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'org',
        operationCode: 'query',
      },
      targetName: '组织管理',
    },
  },
  {
    path: '/admin/org-authority/room-org/org-index',
    name: 'M020045',
    component: () =>
      import('@/views/admin/org-authority/room-org/OrgIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/org-authority/account/account-index',
    name: 'M020010',
    component: () =>
      import('@/views/admin/org-authority/account/AccountIndex.vue'),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'account',
        operationCode: 'query',
      },
      targetName: '账号管理',
    },
  },
];
